import { component } from 'picoapp';
import Drawer from '../../js/utils/drawer';
import Ready from '../../js/utils/ready';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const mobileList = node.querySelector('.js-mobileList');
  const mobileListBtn = node.querySelector('.js-mobileListBtn');
  const mobileListCloseBtn = node.querySelector('.js-mobileListCloseBtn');

  /**
   * Functions
   */
  const init = () => {
    const mobileListDrawer = Drawer(mobileList);

    mobileListBtn.addEventListener('click', () => mobileListDrawer.open());
    mobileListCloseBtn.addEventListener('click', () => mobileListDrawer.close());
  };

  /**
   * Init
   */
  Ready(init);
});
